import { __decorate, __extends } from "tslib";
import AvalonGTView from "@/utils/libs/BaseView";
import NavPanel from "@/components/common/NavPanel.vue";
import { Options } from "vue-class-component";
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
